// extracted by mini-css-extract-plugin
export var root = "_753ecb9b3c43fcaaa9a8d393e96ed5b8-css";
export var pageSizeToolbarWrapper = "_5e495884d66f93f8b6ed54fb89eca165-css";
export var pageNumbers = "_2b3a88819c5c17b41450cee567cab0f1-css";
export var pageSizeInputWrapper = "_3fb53323f1d9402d49ee45bb67e26420-css";